<template>
  <br>
  <strong v-bind="(e) => getTestProps(e, 'titulo-contato')"> Pessoa de contato </strong>
  <br><br>
  <TrfInput
    label="Nome do contato"
    placeholder="Nome do contato"
    margin="0"
    maxLength="150"
    id="processo-form-pessoa-contato-nome"
    v-model="formData.pessoaContatoNome"
    @update:model-value="$event => setPessoaContatoNome($event)"
    ref="campoLegalizacaoContato"
    :mensagemCampoObrigatorio="'Pessoa de contato é obrigatório.'"
  ></TrfInput>
  <TrfEmailInput
    label="E-mail"
    placeholder="E-mail de contato"
    margin="0"
    id="processo-form-pessoa-contato-email"
    v-model="formData.pessoaContatoEmail"
    maxLength="100"
    @update:model-value="$event => setPessoaContatoEmail($event)"
    ref="campoLegalizacaoEmail"
    :mensagemCampoObrigatorio="'E-mail da pessoa de contato é obrigatório.'"
  ></TrfEmailInput>
  <TrfPhoneInput
    label="WhatsAPP"
    placeholder="WhatsAPP de contato"
    margin="0"
    id="processo-form-pessoa-contato-whatsapp"
    v-model="formData.pessoaContatoWpp"
    @update:model-value="$event => setPessoaContatoWpp($event)"
    ref="campoLegalizacaoWhatsAPP"
    :required="false"
  ></TrfPhoneInput>
</template>
<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'TrfProcessosFormularioContato',
  expose: ['inicializarCampos', 'doReset', 'marcarValidacoes', 'validacoes'],
  components: {
    TrfInput: defineAsyncComponent(() => import('../../../../components/Input/index.vue')),
    TrfEmailInput: defineAsyncComponent(() => import('../../../../components/Input/TrfEmailInput.vue')),
    TrfPhoneInput: defineAsyncComponent(() => import('../../../../components/Input/TrfPhoneInput.vue')),
  },
  data() {
    return {
      formData: {
        pessoaContatoNome: '',
        pessoaContatoEmail: '',
        pessoaContatoWpp: ''
      }
    };
  },
  computed: {
    validacoes() {
      const isPessoaContatoNomeValido = !!this.formData.pessoaContatoNome;
      const isPessoaContatoEmailValido = !this.$refs.campoLegalizacaoEmail.verificarSeInputEstaVazio(true) && this.$refs.campoLegalizacaoEmail.verificarSeInputEValido();
      const isPessoaContatoWppValido = this.$refs.campoLegalizacaoWhatsAPP.verificarSeInputEstaVazio(true) || this.$refs.campoLegalizacaoWhatsAPP.verificarSeInputEValido();
      const isFormValido = isPessoaContatoNomeValido && isPessoaContatoEmailValido && isPessoaContatoWppValido;
      const validacoes = {
        form: isFormValido,
        campos: {
          pessoaContatoNome: isPessoaContatoNomeValido,
          pessoaContatoEmail: isPessoaContatoEmailValido,
          pessoaContatoWpp: isPessoaContatoWppValido
        }
      };
      return validacoes;
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler() {
        this.$emit('update:form-data', this.formData)
      },
      deep: true
    },
  },
  methods: {
    setPessoaContatoNome(valor = '') {
      this.formData.pessoaContatoNome = valor;
    },
    setPessoaContatoEmail(valor = '') {
      this.formData.pessoaContatoEmail = valor;
    },
    setPessoaContatoWpp(valor = '') {
      this.formData.pessoaContatoWpp = valor;
    },
    doReset() {
      this.$refs.campoLegalizacaoContato.limparInput();
      this.$refs.campoLegalizacaoContato.limparValidacao();
      this.$refs.campoLegalizacaoEmail.limparInput();
      this.$refs.campoLegalizacaoEmail.limparValidacao();
      this.$refs.campoLegalizacaoWhatsAPP.limparInput();
      this.$refs.campoLegalizacaoWhatsAPP.limparValidacao();
      this.formData = {
        pessoaContatoNome: '',
        pessoaContatoEmail: '',
        pessoaContatoWpp: ''
      }
    },
    marcarValidacoes() {
      if (!this.validacoes.campos.pessoaContatoNome) {
        this.$refs.campoLegalizacaoContato.verificarSeInputEstaVazio()
      }
      if (!this.validacoes.campos.pessoaContatoEmail) {
        this.$refs.campoLegalizacaoEmail.verificarSeInputEstaVazio()
      }
    },
    getTestProps(e, ref) {
      if(!e.id && !ref) {
        return {};
      }
      const identifier = !!ref? ref : e.id;
      return {
        'data-cy': identifier,
        'data-label': identifier
      }
    },
    inicializarCampos(dados) {
      this.setPessoaContatoNome(dados.pessoaContatoNome);
      this.setPessoaContatoEmail(dados.pessoaContatoEmail);
      this.setPessoaContatoWpp(dados.pessoaContatoWpp);
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
</style>
